"use client";
import React from "react";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { cn } from "utils/utils";
import { formatCurrency } from "utils/currency";
import { useSwapCalculatorComputed } from "modules/swap-calculator/stores/useSwapCalculatorStore";
import { useUserPreferences } from "modules/auth/hooks/useUserPreferences";

function TradeValues() {
  const { preferences } = useUserPreferences();
  const currency = preferences.pricing.currency;
  const { leftTotal, rightTotal, difference, isLeftHigher, isRightHigher } =
    useSwapCalculatorComputed();

  return (
    <div className="border-secondary-dark w-full border-y">
      <div className="grid grid-cols-8 items-center justify-between gap-4 py-2 md:py-4">
        {/* Left Total */}
        <div className="col-span-2 flex items-center justify-start">
          <span className="text-secondary text-lg font-semibold md:text-xl">
            {formatCurrency(leftTotal, currency)}
          </span>
        </div>

        {/* Left Arrow */}
        <div className="col-span-1 flex items-center justify-center">
          <ChevronsLeft
            className={cn(
              "h-8 w-8 md:h-12 md:w-12",
              isLeftHigher ? "text-primary" : "text-secondary-dark"
            )}
          />
        </div>

        {/* Difference */}
        <div className="col-span-2 flex justify-center">
          <span
            className={cn(
              "border-x px-4 py-1 text-lg font-semibold md:py-2 md:text-xl",
              isLeftHigher
                ? "border-primary text-primary"
                : isRightHigher
                  ? "border-secondary text-secondary"
                  : "border-secondary-dark text-secondary-dark"
            )}
          >
            {formatCurrency(difference, currency)}
          </span>
        </div>

        {/* Right Arrow */}
        <div className="col-span-1 flex items-center justify-center">
          <ChevronsRight
            className={cn(
              "h-8 w-8 md:h-12 md:w-12",
              isRightHigher ? "text-secondary" : "text-secondary-dark"
            )}
          />
        </div>

        {/* Right Total */}
        <div className="col-span-2 flex items-center justify-end">
          <span className="text-primary text-lg font-semibold md:text-xl">
            {formatCurrency(rightTotal, currency)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default TradeValues;
